module.exports = __webpack_public_path__ + "img/REFRESH.5b338720.svg";